var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container ime-twelve-col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_vm._t("slot1")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }